/**
 * @author       grady@zumper.com (Grady Kuhnline)
 * @copyright    Copyright (c) 2018, Zumper
 * @description  Constants for history-middleware
 */

export const GET_ROUTE_PROPS = '@@zumper/history-middleware/GET_ROUTE_PROPS'
export const GO = '@@zumper/history-middleware/GO'
export const GO_BACK = '@@zumper/history-middleware/GO_BACK'
export const GO_FORWARD = '@@zumper/history-middleware/GO_FORWARD'
export const LISTEN = '@@zumper/history-middleware/LISTEN'
export const MATCH = '@@zumper/history-middleware/MATCH'
export const PUSH = '@@zumper/history-middleware/PUSH'
export const REPLACE = '@@zumper/history-middleware/REPLACE'
export const START_HISTORY_MIDDLEWARE = '@@zumper/history-middleware/START_HISTORY_MIDDLEWARE'
export const STOP_HISTORY_MIDDLEWARE = '@@zumper/history-middleware/STOP_HISTORY_MIDDLEWARE'
export const UNLISTEN = '@@zumper/history-middleware/UNLISTEN'

// HASH
export const DELETE_HASH_QUERY = '@@zumper/history-middleware/DELETE_HASH_QUERY'
export const PUSH_HASH = '@@zumper/history-middleware/PUSH_HASH' // pushes the current location with a new hash
export const REPLACE_HASH = '@@zumper/history-middleware/REPLACE_HASH' // replaces the current location with a new hash
export const DELETE_HASH = '@@zumper/history-middlware/DELETE_HASH'
export const SET_HASH_QUERY = '@@zumper/history-middleware/SET_HASH_QUERY'

// SEARCH
export const DELETE_QUERY = '@@zumper/history-middleware/DELETE_QUERY'
export const PUSH_SEARCH = '@@zumper/history-middleware/PUSH_SEARCH'
export const REPLACE_SEARCH = '@@zumper/history-middleware/REPLACE_SEARCH'
export const SET_QUERY = '@@zumper/history-middleware/SET_QUERY'
